import React from 'react';
import { motion, useReducedMotion } from 'motion/react';
import Reveal from './Reveal';
import './ui.css';

const EASE = [0.22, 1, 0.36, 1];

const SectionHeader = ({ eyebrow, title, lede, align = 'left' }) => {
  const reduce = useReducedMotion();
  const words = title.split(' ');
  return (
    <div className={`sh sh--${align}`}>
      <Reveal as="span" className="eyebrow" y={10}>{eyebrow}</Reveal>
      <h2 className="t-display t-section sh-title" aria-label={title}>
        {words.map((word, i) => (
          <span className="sh-word" key={`${word}-${i}`} aria-hidden="true">
            <motion.span
              style={{ display: 'inline-block' }}
              initial={reduce ? { opacity: 0 } : { y: '110%' }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: '0px 0px -60px 0px' }}
              transition={{ duration: 0.8, ease: EASE, delay: 0.05 + i * 0.07 }}
            >
              {word}
            </motion.span>
          </span>
        ))}
      </h2>
      {lede && (
        <Reveal className="sh-lede" delay={0.18}>
          <p>{lede}</p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeader;
